import { graphql } from 'react-apollo'
import { Layout, Table, Input } from 'antd'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Footer from '../components/Footer'
import labelGroupAllQuery from '../graphql/queries/labelGroupAll'
import Navbar from '../components/Navbar'

import '../css/table.css'

const { Content } = Layout

class LabelGroupAll extends Component {
  state = {
    searchKey: '',
  }


  render () {

    const searchKey = this.state.searchKey.toLowerCase()
    const { labelGroupAll: { loading, labelGroupAll = [] } } = this.props
    let groups = labelGroupAll.map(group => ({ group })).reverse()
    if(searchKey !== ''){
      groups = groups.filter(groupData => groupData.group.toLowerCase().includes(searchKey))
    }

    const columns = [
      {
        title: 'Group',
        key: 'group',
        render: record => (<Link to={`/label/${record.group}`}>{record.group}</Link>),
      },
    ]

    return (
      <Layout>
        <Navbar selected="label:3" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <h2>Label Group</h2>

            <Input.Search placeholder='Search Group' style={{ float: 'right', marginBottom: '10px', width: '250px'}} onChange={ e => this.setState({searchKey: e.target.value})} /><br />

            <Table
              dataSource={ groups }
              columns={columns}
              rowKey="group"
              pagination={{ pageSize: 50 }}
              size="middle"
              loading={loading}
              bordered
            />
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}

LabelGroupAll.propTypes = {
  labelGroupAll: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    labelGroupAll: PropTypes.array,
  }).isRequired,
}
LabelGroupAll.defaultProps = {}

export default graphql(labelGroupAllQuery, { name: 'labelGroupAll' })(LabelGroupAll)



// WEBPACK FOOTER //
// ./src/pages/LabelGroupAll.js